import styled from 'styled-components';
import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    Cabecalho, Propaganda, NavBAr, Navegacao, Logo, ContaiterLogo, Links, NavLinks, ImgShop, ContainerShop, Pesquisa, ContainerPesquisa, BarraPesquisa,
    ContainerCompra, Usuario, Favorito, Sacola, MenuMobile, Input, CarrinhoCompras, CarrinhoHeader, ContainerCarrinhoP,
    ContainerP, ContainerSacolinha, CarrinhoMain, CarrinhoRodape, CardP, ImgCardP, ContainerCardp, ContainerProduto,
    DadosProduto, NomeProduto, ContainerRemover, ContainerValoresP, UnidadeP, VezesP, ValorP, CarrinhoValor, ContainerSubtotal,
    SubtotalP, ContainerValorTotal, ValorTotalP, ContainerFinalizar, ButtonFinalizar, ContainerFinalizarP, FinalizarP,
    ContinuarCompraP, IconMaior, MenuMobileLateral, ContainerMenuMobile, Shop, ContainerTitulo, Titulo, Pagina, MaisOpcoesMobile, PesquisaMobile, BarraPesquisaMobile, ContainerBarraPesquisaMobile, OpcoesMobile, CadastroBox,
    ContainerOpcoes, UsuarioMobile, ButtonContaMobile, Contap, ContainerTituloMobile, ContainerSeta, Paginas
} from './Home.style.js';

import MenuImage from '../components/assets/menu.png';
import MarcaCruzada from '../components/assets/marca-cruzada.png';

import PesquisaSvg from '../components/svg/pesquisa.svg';
import UsuarioSvg from '../components/svg/usuario.svg';
import FavoritoSvg from '../components/svg/favorito.svg';
import SacolaSvg from '../components/svg/sacola.svg';
import SacolaSairSvg from '../components/svg/sacolaSair.svg';
import ExcluirSvg from '../components/svg/excluir.svg';
import Maior2 from '../components/svg/maior2.svg';
import MaisOpcoes from '../components/svg/maisopcoes.svg';
import SairOpcoes from '../components/svg/sairOpcoes.svg';
import SetaAcordeon from '../components/svg/setaAcordeon.svg';
import SetaPagina from '../components/svg/setaPagina.svg';
import Adcionar from '../components/svg/adcionar.svg';
import Remover from '../components/svg/remover.svg';
import LupaPesquisa from '../components/svg/lupaPesquisa.svg';
import API from '../examples/modelo_api_home.json'
import apiService from "../api/home.js";



import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Menus({ DadosAPI }) {


    const shop = DadosAPI.menu;

    const [carrinhoVisivel, setCarrinhoVisivel] = useState(false);
    const [shopVisivel, setShopVisivel] = useState(false);
    const [barraVisivel, setBarraVisivel] = useState(false);
    const [openSections, setOpenSections] = useState({});
    const [ItensCarrinho, setItensCarrinho] = useState([]);



    const toggleCarrinho = () => setCarrinhoVisivel(!carrinhoVisivel);
    const fecharCarrinho = () => setCarrinhoVisivel(false);

    const toggleShop = () => setShopVisivel(!shopVisivel);
    const toggleBarra = () => setBarraVisivel(!barraVisivel);

    // Estado para armazenar o índice do menu aberto
    const [activeMenu, setActiveMenu] = useState(null);

    // Define a função global no window
    useEffect(() => {
        window.atualizarCarrinho = atualizarCarrinho;
        return () => {
            delete window.atualizarCarrinho; // Limpeza na desmontagem
        };
    }, []);

    useEffect(() => {
        atualizarCarrinho()
    }, []);




    const atualizarCarrinho = async (status) => {
        setItensCarrinho([])
        atualizarRenderCarrinho()

        if (status && status == 'abrirCarrinho') {
            toggleCarrinho(true)
        }
    }

    const atualizarRenderCarrinho = async () => {

        var get_dados_carrinho = await localStorage.getItem('@carrinho')

        if (get_dados_carrinho == null || get_dados_carrinho == '') {
            get_dados_carrinho = '[]'
        }

        get_dados_carrinho = JSON.parse(get_dados_carrinho)

        console.log('get_dados_carrinho', get_dados_carrinho)
        setItensCarrinho(get_dados_carrinho)
    }

    const toggleSection = (index) => {
        setOpenSections((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const [menuStates, setMenuStates] = useState(() =>
        shop.reduce((acc, section, index) => {
            acc[index] = false; // Inicializa cada menu como fechado
            return acc;
        }, {})
    );


    const somarTotal = (item) => {

        let total = 0;

        for (let i = 0; i < item.length; i++) {
            const produto = item[i];
            const preco = parseFloat(produto.preco.replace(",", "."));
            total += preco * produto.quantidade;
        }

        return total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

    }

    const clickExcluir = async (index) => {
        // Recupera o carrinho existente no localStorage
        const carrinho = JSON.parse(localStorage.getItem('@carrinho')) || [];

        // Verifica se o índice é válido
        if (index >= 0 && index < carrinho.length) {
            // Remove o item do carrinho pelo índice
            carrinho.splice(index, 1);

            // Atualiza o localStorage com o carrinho atualizado
            localStorage.setItem('@carrinho', JSON.stringify(carrinho));
            console.log('Item removido com sucesso!');
            atualizarCarrinho()

            toast.error('Item removido do carrinho!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            console.error('Índice inválido. Nenhum item foi removido.');
        }
    }


    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
        toggleMenuCloseAll();
    }, [pathname]);;

    const toggleMenu = (index) => {
        // Verifica se algum menu está aberto
        const isAnyMenuOpen = Object.values(menuStates).some((state) => state === true);

        if (isAnyMenuOpen) {
            // Se algum menu está aberto, fecha todos
            toggleMenuCloseAll();
        } else {
            // Caso contrário, alterna o menu específico
            setMenuStates((prev) =>
                Object.keys(prev).reduce((newState, key) => {
                    newState[key] = parseInt(key) === index ? !prev[index] : false;
                    return newState;
                }, {})
            );
        }
    };

    const toggleMenuCloseAll = () => {
        setMenuStates((prevState) => {
            const allFalse = Object.keys(prevState).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            return allFalse;
        });
    };

    //Navegacao lista de pordutos

    const navigate = useNavigate();

    const handleNavigateToWishlist = () => {
        navigate('/perfil', { state: { activeSection: 'Minha lista de desejos' } });
    };


    const SVGElement = ({ aberto }) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                style={{
                    transition: 'transform 0.3s ease',
                    transform: `rotate(${aberto ? '-180deg' : '0deg'})`,
                    marginLeft: '10px',
                }}
            >
                <path
                    d="M1.42857 0.142852L5 3.71428L8.57143 0.142853L10 0.857138L5 5.85714L-3.12224e-08 0.857138L1.42857 0.142852Z"
                    fill="#252B42"
                />
            </svg>
        )
    }


    function renderImg(item) {
        const getAmbiente = apiService.ambiente();

        var imgPrincipal = item.urlfotoprincipal;

        if (item.urlfotoprincipal == null || item.urlfotoprincipal == null) {
            if (item.fotos && item.fotos.length > 0) {
                imgPrincipal = item.fotos[0].urlfoto
            }
        }

        var get_item_url = imgPrincipal;
        var url = getAmbiente + "/" + get_item_url

        return url

    }

    const fecharMenu = () => {
        setShopVisivel(false);
    };

    const [openSubMenus, setOpenSubMenus] = useState({}); // Estado para controlar os menus de terceira fase

    // Função para alternar o estado de um menu específico
    const toggleThirdMenu = (subMenuIndex) => {
        setOpenSubMenus((prev) => ({
            ...prev,
            [subMenuIndex]: !prev[subMenuIndex],
        }));
    };

    return (
        <Cabecalho>
            <NavBAr>
                <Navegacao>
                    <MaisOpcoesMobile onClick={toggleShop}>
                        <img src={shopVisivel ? SairOpcoes : MaisOpcoes} alt="Opções" />
                    </MaisOpcoesMobile>
                    <ContaiterLogo>
                        <img style={{ width: 70, height: 70, objectFit: 'contain' }} src={DadosAPI.cabecalho[0].urllogo}></img>
                    </ContaiterLogo>
                    <Links>
                        {shop.map((section, index) => {

                            const urlbannermenuon = shop.find(i => i.urlbannermenu && i.urlbannermenu.trim() !== "")?.urlbannermenu;

                            function renderImgUrl(path) {
                                const getAmbiente = apiService.ambiente();
                                return `${getAmbiente}/${path}`;
                            }

                            // com submenus
                            if (section.menu && section.menu.length > 0) {

                                var subMenus = section.menu;

                                return (
                                    <NavLinks
                                        key={index}
                                        onClick={() => toggleMenu(index)}

                                    >
                                        {section.ecommercemenu}
                                        <SVGElement aberto={menuStates[index]} />


                                        <ContainerShop visivel={menuStates[index]}>
                                            <Shop>
                                                <div style={{ display: 'flex' }}>
                                                    {subMenus.map((section_sub) => {


                                                        var menus_terceira_fase = section_sub.menu

                                                        return (
                                                            <ContainerTitulo key={section}>
                                                                <Link style={{ textDecoration: 'none', color: '#737373' }} to={`/produto?categoria=${section_sub.idcategoriasite}`}>
                                                                    <Titulo>
                                                                        {section_sub.ecommercemenu}
                                                                    </Titulo>
                                                                </Link>
                                                                <Paginas>
                                                                    {menus_terceira_fase.map((pagina, index) => (
                                                                        <Pagina key={index} style={{ whiteSpace: 'pre-line' }}>
                                                                            <Link style={{ textDecoration: 'none', color: '#737373' }} to={`/produto?categoria=${pagina.idcategoriasite}`}>
                                                                                {pagina.ecommercemenu}
                                                                            </Link>
                                                                        </Pagina>
                                                                    ))}
                                                                </Paginas>
                                                            </ContainerTitulo>
                                                        )
                                                    })}
                                                </div>
                                            </Shop>

                                            {/* <ImgShop><img style={{ width: '100%', height: '100%' }} src={'https://dev.barontechsistemas.com.br/anexos/ecommerce/1384/1/banner/banner_produtos.png'} /></ImgShop> */}
                                            <ImgShop>
                                                {urlbannermenuon ? (
                                                    <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={renderImgUrl(urlbannermenuon)} alt="Banner" />
                                                ) : null}
                                            </ImgShop>
                                        </ContainerShop>
                                    </NavLinks>
                                )
                            }

                            //Caso nao tenha submenus
                            return (
                                <NavLinks>
                                    <Link style={{ textDecoration: 'none', color: 'black' }} to={section.urlmenu == 'index' ? '/' : section.urlmenu}>
                                        {section.ecommercemenu}
                                    </Link>
                                </NavLinks>
                            )
                        })}

                        <OpcoesMobile visivel={shopVisivel}>
                            <ContainerOpcoes>
                                <div>
                                    <CadastroBox>
                                        <UsuarioMobile>
                                            <img src={UsuarioSvg} alt="Usuário" />
                                        </UsuarioMobile>
                                        <Link onClick={() => fecharMenu()} style={{ textDecoration: 'none' }} to="/account" state={{ showLogin: true }}>
                                            <ButtonContaMobile>
                                                <Contap>Entrar</Contap>
                                            </ButtonContaMobile>
                                        </Link>
                                        <Link onClick={() => fecharMenu()} style={{ textDecoration: 'none' }} to="/account" state={{ showLogin: false }}>
                                            <ButtonContaMobile>
                                                <Contap>Criar conta</Contap>
                                            </ButtonContaMobile>
                                        </Link>
                                    </CadastroBox>
                                    <div style={{ marginTop: 30, marginBottom: 30 }}>

                                        {shop.map((section, index) => {

                                            // com submenus
                                            if (section.menu && section.menu.length > 0) {

                                                var subMenus = section.menu;

                                                return (
                                                    <ContainerTituloMobile key={index}>
                                                        <ContainerSeta onClick={() => toggleSection(index)}>
                                                            <Titulo>
                                                                {section.ecommercemenu}
                                                            </Titulo>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <img src={openSections[index] ? Remover : Adcionar} alt="Toggle Icon" />
                                                            </div>
                                                        </ContainerSeta>

                                                        <Paginas isOpen={openSections[index]}>
                                                            {subMenus.map((section_sub, index2) => {
                                                                const menus_terceira_fase = section_sub.menu || [];

                                                                return (
                                                                    <React.Fragment key={index2}>
                                                                        <ContainerSeta>
                                                                            <Pagina style={{ marginBottom: 0 }}>
                                                                                <Link
                                                                                    onClick={() => fecharMenu()}
                                                                                    style={{ textDecoration: 'none', color: '#737373' }}
                                                                                    to={`/produto?categoria=${section_sub.idcategoriasite}`}
                                                                                >
                                                                                    {section_sub.ecommercemenu}
                                                                                </Link>
                                                                            </Pagina>
                                                                            {menus_terceira_fase[0] ? <img
                                                                                src={SetaPagina}
                                                                                alt="Arrow Icon"
                                                                                onClick={() => toggleThirdMenu(index2)} // Alterna o menu de terceira fase
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    rotate: openSubMenus[index2] ? '270deg' : null,
                                                                                    paddingRight: openSubMenus[index2] ? '15px' : '5px'
                                                                                }}
                                                                            /> : null}
                                                                        </ContainerSeta>

                                                                        {openSubMenus[index2] && (
                                                                            <div style={{ marginLeft: '20px', marginTop: '5px' }}>
                                                                                {menus_terceira_fase.map((pagina, index3) => (
                                                                                    <Pagina key={index3} style={{ whiteSpace: 'pre-line' }}>
                                                                                        <Link
                                                                                            onClick={() => fecharMenu()}
                                                                                            style={{ textDecoration: 'none', color: '#737373' }}
                                                                                            to={`/produto?categoria=${pagina.idcategoriasite}`}
                                                                                        >
                                                                                            {pagina.ecommercemenu}
                                                                                        </Link>
                                                                                    </Pagina>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </Paginas>
                                                    </ContainerTituloMobile>
                                                )
                                            }

                                            //Caso nao tenha submenus
                                            return (
                                                <ContainerTituloMobile key={index}>
                                                    <ContainerSeta >
                                                        <Titulo onClick={() => { navigate("./" + section.ecommercemenu); fecharMenu(); }}>
                                                            {section.ecommercemenu}
                                                        </Titulo>
                                                    </ContainerSeta>
                                                </ContainerTituloMobile>
                                            )
                                        })}

                                        {/* {shop.map((section, index) => (
                                            <ContainerTituloMobile key={index}>
                                                <ContainerSeta onClick={() => toggleSection(index)}>
                                                    <Titulo>TESTE{index}{section.ecommercemenu}</Titulo>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={openSections[index] ? Remover : Adcionar} />
                                                    </div>
                                                </ContainerSeta>

                                                
                                                {section.menu.map((section_sub, index2) => (
                                                <Paginas isOpen={!!openSections[index2]}>
                                                    <ContainerSeta >
                                                        <Pagina style={{ marginBottom: 0 }}><Link style={{ textDecoration: 'none', color: '#737373' }} to="/">{section_sub.ecommercemenu}</Link></Pagina>
                                                        <img src={SetaPagina} />
                                                    </ContainerSeta>
                                                     
                                                </Paginas>
                                                ))}


                                            </ContainerTituloMobile>
                                        ))} */}
                                    </div>
                                </div>
                            </ContainerOpcoes>
                        </OpcoesMobile>
                    </Links>
                </Navegacao>
                <Pesquisa>
                    {/* <ContainerPesquisa>
                        <BarraPesquisa>
                            <Input type="text" placeholder="Pesquisar"></Input>
                            <img src={PesquisaSvg} alt="Pesquisar" />
                        </BarraPesquisa>
                    </ContainerPesquisa> */}
                    <ContainerCompra>
                        <Usuario>
                            <Link style={{ textDecoration: 'none', color: 'black' }} to="/account"><img src={UsuarioSvg} alt="Usuário" /></Link>
                        </Usuario>
                        {/* <PesquisaMobile onClick={toggleBarra}>
                            <img src={LupaPesquisa} alt="Pesquisar" />
                        </PesquisaMobile> */}
                        {/* <Favorito onClick={handleNavigateToWishlist}>
                            <img src={FavoritoSvg} alt="Favorito" />
                        </Favorito> */}
                        <Sacola onClick={() => {
                            toggleCarrinho()
                        }}>
                            <img src={SacolaSvg} alt="Sacola" />
                        </Sacola>
                    </ContainerCompra>
                </Pesquisa>
            </NavBAr>
            {/* <ContainerBarraPesquisaMobile visivel={barraVisivel}>
                <BarraPesquisaMobile>
                    <Input type="text" placeholder="Pesquisar"></Input>
                    <img src={PesquisaSvg} alt="Pesquisar" />
                </BarraPesquisaMobile>
            </ContainerBarraPesquisaMobile> */}
            <CarrinhoCompras visivel={carrinhoVisivel}>
                <CarrinhoHeader>
                    <ContainerCarrinhoP>
                        <ContainerP>Carrinho de compras</ContainerP>
                    </ContainerCarrinhoP>
                    <ContainerSacolinha onClick={fecharCarrinho}>
                        <img src={SacolaSairSvg} alt="Fechar" />
                    </ContainerSacolinha>
                </CarrinhoHeader>
                <CarrinhoMain>


                    {ItensCarrinho.length == 0 && (
                        <>
                            <div style={{ justifyContent: 'center', display: 'flex', marginTop: 20 }}>
                                <ValorTotalP >Seu carrinho está vázio</ValorTotalP>
                            </div>
                        </>
                    )}

                    {ItensCarrinho.map((i, index) => {

                        return (<CardP>
                            <ImgCardP><img style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 5, minWidth: 30 }} src={renderImg(i)} /></ImgCardP>
                            <ContainerCardp>
                                <ContainerProduto>
                                    <DadosProduto>
                                        <NomeProduto>{i.tituloloja}</NomeProduto>
                                        <ContainerValoresP>
                                            <UnidadeP>{i.quantidade}</UnidadeP>
                                            <VezesP>X</VezesP>
                                            <ValorP>R$ {i.preco}</ValorP>
                                        </ContainerValoresP>
                                    </DadosProduto>
                                </ContainerProduto>

                            </ContainerCardp>

                            <ContainerRemover onClick={() => clickExcluir(index)}>
                                <img src={ExcluirSvg} alt="Excluir" />
                            </ContainerRemover>
                        </CardP>


                        )
                    })}

                </CarrinhoMain>
                <CarrinhoValor>
                    <ContainerSubtotal>
                        <SubtotalP>Subtotal</SubtotalP>
                    </ContainerSubtotal>
                    <ContainerValorTotal>
                        <ValorTotalP> {somarTotal(ItensCarrinho)}</ValorTotalP>
                    </ContainerValorTotal>
                </CarrinhoValor>
                <CarrinhoRodape>
                    <ContainerFinalizar>
                        <div style={{ textDecoration: 'none' }} onClick={() => {

                            navigate("/checkout")
                            fecharCarrinho()
                        }}>
                            <ButtonFinalizar>
                                <ContainerFinalizarP>
                                    <FinalizarP>Finalizar</FinalizarP>
                                </ContainerFinalizarP>
                                <IconMaior>
                                    <img src={Maior2} alt="Maior" />
                                </IconMaior>
                            </ButtonFinalizar>
                        </div>
                        <ContinuarCompraP onClick={fecharCarrinho}>Continuar comprando</ContinuarCompraP>
                    </ContainerFinalizar>
                </CarrinhoRodape>
            </CarrinhoCompras>
        </Cabecalho>
    );
}

export default Menus;
